import section1 from "../assets/homeCarousel/section1.png";
import section2 from "../assets/homeCarousel/section2.png";
export const homeCarouselData = [
  {
    id: 1,
    title: "True Deliciousness and legacy in making sweets",
    titleTe: "స్వీట్ల తయారీలో నిజమైన రుచి మరియు వారసత్వం",
    desc: "With over 50 years of legacy and deliciousness in making sweets, we are truly committed to the customer satisfaction.",
    descTe: "50 సంవత్సరాలకు పైగా వారసత్వం మరియు రుచితో స్వీట్లు తయారు చేస్తూ, మేము వినియోగదారుల సంతృప్తికి నిజంగా కట్టుబడి ఉన్నాము.",
    image: section1,
    imageDesc: "about-section",
    path: "/about",
  },
  {
    id: 2,
    title: "Wide Range of Delicious Sweets",
    titleTe: "రుచికరమైన స్వీట్ల విస్తృత శ్రేణి",
    desc: "Explore our wide range of deliciouse and quality sweets at very affordable prices.",
    descTe: "చాలా సరసమైన ధరలలో మా విస్తృత శ్రేణి రుచికరమైన మరియు నాణ్యమైన స్వీట్లను చూడండి.",
    image: section2,
    imageDesc: "sweets-section",
    path: "/sweets",
  },
];
